import '@expo/metro-runtime';

if (__DEV__) {
  // In development with reduced motion, a reanimated log is called before the logger is initialized
  // unless we import the following side effect import before the whole package
  // This may be fixed in 3.x
  // https://github.com/software-mansion/react-native-reanimated/blob/9b99fbd843f490261e04d8cc354ee1aced860c45/packages/react-native-reanimated/src/animation/util.ts#L46-L50
  require('react-native-reanimated/src/initializers');
}
